/*根据版本号获取行政区*/
import api from "../../../../api/api_sys_manage";
import Cookies from 'js-cookie'


/*根据版本请求行政区数据接口*（*/
let set_recordLog_by_data =  async function(value){
  try{
    let res = await api.recordLog({
      userid: window.vue.GLOBAL.common_tool.get_user_info().user_id,
      loginname: window.vue.GLOBAL.common_tool.get_user_info().user_name,
      realname: window.vue.GLOBAL.common_tool.get_user_info().real_name,
      operaname: value,
    });

    if(res.code == 200) {
      console.log(`记录用户操作成功`)
    }else {
      console.error(`获记录用户操作失败返回code非0，${res.msg}`)
    }
  }catch (e) {
    console.error(`获记录用户操作错误`)
  }
};
export default {
  set_recordLog_by_data,
}



// WEBPACK FOOTER //
// ./src/assets/js/global_tool/sys_tool/api_recordLog_sz_by_data.js